<div class="row mt-4">
  <div class="col-md-12">
      <div class="row mb-3">
        <div class="col-5 mr-auto">
          <h3>DN Records Received From Partner</h3>
        </div>
        <div class="col-2 ml-auto">
          <label class="mb-0" for=""><u>Items Per Page</u></label>
          <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
            <option *ngFor="let ipp of pagingList">{{ipp}}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for=""><span class="text-danger">* </span><u>From</u></label>
          <input type="date" [(ngModel)]="filterable.from" class="form-control" placeholder="From">
        </div>
        <div class="col">
          <label for=""><span class="text-danger">* </span><u>To</u></label>
          <input type="date" [(ngModel)]="filterable.to" class="form-control" placeholder="From">
        </div>
        <div class="col">
          <label for="gotoShortCode"><u>Goto ShortCode</u></label>
          <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
          </ng-select>
        </div>
        <div class="col">
          <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
          <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
            <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
          </select>
        </div>
        <div class="col">
          <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
          <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (ngModelChange)="changeCountry($event)">
            <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value" >{{country.key}}</option>
          </select>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <label for=""><u>Filter by Operator</u></label>
          <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator" (ngModelChange)="changeOperator($event)">
            <option value=null selected>- select operator-</option>
            <option *ngFor="let op of operatorList | keyvalue" [ngValue]="op.key">{{op.key}}</option>
          </select>
        </div>
        <div class="col">
          <label for=""><u>Filter by Short Code</u></label>
          <!-- <input type="text" formControlName="shortCode" class="form-control" placeholder="enter short code" /> -->
          <ng-select [items]="shortCodeList" (clear)="onClear()" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
          </ng-select>
        </div>
        <div class="col">
          <label for=""><u>Filter by Keyword</u></label>
          <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword">
            <option value=null selected>-select keyword-</option>
            <option *ngFor="let kw of keywordList" [ngValue]="kw">{{kw.keyword}}</option>
          </select>
        </div>
        <div class="col">
          <label for=""><u>Filter by Phone</u></label>
          <input type="text" [(ngModel)]="filterable.phone" class="form-control" placeholder="enter phone" />
        </div>
        <div class="col">
          <label for=""><u>Filter by Process State</u></label>
          <select [(ngModel)]="filterable.panOutState" class="form-control" placeholder="Process State">
            <option value="" selected>All</option>
            <option *ngFor="let state of panOutList | keyvalue" [value]="state.key">{{state.value}}</option>
          </select>
        </div>
      </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <div class="col-10 ml-auto text-right align-self-end">
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
  </div>
  <!-- <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div>
</div> -->
  <!-- <div class="table-responsive"> -->
  <table id="dnRecordList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
    <thead>
      <tr>
        <th>No.</th>
        <th>Msg ID</th>
        <th>ShortCode</th>
        <th>Keyword</th>
        <th>Operator</th>
        <th>Phone</th>
        <th>Charge</th>
        <th>Status</th>
        <th>Process State</th>
        <th>Received At</th>
        <th>Transaction At</th>
        <th>Operate</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="loading">
        <td colspan="13">
          <div class="loader">Loading...</div>
        </td>
      </tr>
      <tr *ngIf="emptyResult">
        <td colspan="13">
          <div class="alert alert-warning">Empty Result...</div>
        </td>
      </tr>
      <tr *ngFor="let dnRecord of dnRecords; index as i;">
        <td>{{i + 1}}</td>
        <td>{{dnRecord.msgId}}</td>
        <td>{{dnRecord.shortCode}}</td>
        <td>{{dnRecord.keyword}}</td>
        <td>{{dnRecord.operator}}</td>
        <td>{{dnRecord.phone}}</td>
        <td class="text-right">{{dnRecord.charge}}</td>
        <td>{{dnRecord.status}}</td>
        <td>{{dnRecord.panOutMsg}}</td>
        <td>{{dnRecord.receivedAt}}</td>
        <td>{{dnRecord.transactionAt}}</td>
        <td>
          <a type="button" class="btn btn-sm btn-primary mr-2 mt-2 text-white" placement="top" ngbTooltip="View" (click)="openModal(viewDnRecords, dnRecord)">
            <i class="fas fa-eye"></i>
          </a>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="13" *ngIf="!loading && !emptyResult">
          <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
            lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        </td>
      </tr>
    </tfoot>
  </table>
  <!-- </div> -->

  <ng-template #viewDnRecords let-modal>
    <div class="modal-header">
      <h5 class="modal-title" id="viewDnRecordsLabel">Dn Record Detail</h5>
      <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body" id="viewDnRecords-modal-body">
        <dl class="row" *ngFor="let item of selectedDnRecord | keyvalue">
            <dt class="col-sm-4 text-right">{{item.key}}</dt>
            <dd class="col-sm-8" *ngIf="!(item.key.endsWith('At'))">{{item.value }}</dd>
            <dd class="col-sm-8" *ngIf="item.key.endsWith('At')">{{item.value |date :"long" }}</dd>
        </dl>
    </div>
  </ng-template>
